import React from 'react'

const styles = {
  message: {
    color: 'white',
    fontSize: '0.75em',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '22px',
    fontWeight: 'bold',
    right: '36px',
    top: '4px',
    width: '22px',
    height: '22px',
    borderRadius: '50%',
    zIndex: '50',
    backgroundColor: '#673ab7',
    position: 'absolute',
  },
  tasks: {
    color: 'white',
    fontSize: '0.75em',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '22px',
    fontWeight: 'bold',
    right: '36px',
    top: '4px',
    width: '22px',
    height: '22px',
    borderRadius: '50%',
    zIndex: '50',
    backgroundColor: '#ffb900',
    position: 'absolute',
  },
}

const NotificationBadge = ({ page, numNotes }) => (
  <div className="Notification" style={page === 'Message' ? styles.message : styles.tasks}>
    {numNotes}
  </div>
  )

export default NotificationBadge



// WEBPACK FOOTER //
// ./src/components/sitewide/NotificationBadge.js